module.exports = __webpack_public_path__ + "img/logo-UNNE-negativo.5f9c8b28.png";